import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { environment } from './environments/environment';
import { provideIndexedDb } from 'ngx-indexed-db';

const dbConfig = {
    name: 'StoresDB',
    version: 1,
    objectStoresMeta: [{
        store: 'stores',
        storeConfig: { keyPath: 'id', autoIncrement: false },
        storeSchema: [
            { name: 'data', keypath: 'data', options: { unique: false } },
            { name: 'timestamp', keypath: 'timestamp', options: { unique: false } },
            { name: 'filters', keypath: 'filters', options: { unique: false } }
        ]
    }]
};


export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } },
            ripple: true,
            translation: {
                startsWith: 'Inizia con',
                contains: 'Contiene',
                notContains: 'Non contiene',
                endsWith: 'Termina con',
                equals: 'Uguale a',
                notEquals: 'Diverso da',
                noFilter: 'Nessun filtro',
                apply: 'Applica',
                clear: 'Pulisci',
                matchAll: 'Tutti i criteri',
                matchAny: 'Almeno un criterio'
            }
        }),
        // IndexedDB Configuration
        provideIndexedDb(dbConfig),
        // Firebase Configuration
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideStorage(() => getStorage())
    ]
};